import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaSocioeconomicaInterface } from "../../../../../interfaces/FechaSocioeconomicaInterface";
import { ConclusionLlenadaSEInterface } from "../../../../../interfaces/ConclusionLlenadaSEInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Label, TextInput } from "flowbite-react";
import { Button } from "flowbite-react";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { EvaluacionPatrimonial1ListaPrint } from "./EvaluacionPatrimonial1ListaPrint";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const EvaluacionPatrimonial1ListaScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "EVALUACIÓN PATRIMONIAL 1";
  const { control, reset, getValues } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [notes, setNotes] = useState<string[]>([]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);
  const [showOtherInput, setShowOtherInput] = useState(false);

  const [formData, setFormData] = useState({
    visitDate: "",
    name: "",
  });

  const imageUrl = `http://localhost:8000/storage/evaluados/photos/${evaluadosList_id}/Croquis.png`;

  const buildIntegrantesText = () => {
    const hijos = Number(queryEvaluado.data?.cuantos_hijos) || 0;
    const edades = [
      queryEvaluado.data?.edad_hijo1,
      queryEvaluado.data?.edad_hijo2,
      queryEvaluado.data?.edad_hijo3,
      queryEvaluado.data?.edad_hijo4,
    ].filter((edad) => edad);

    let texto = `${hijos} hijo${hijos !== 1 ? "s" : ""}`;

    if (edades.length > 0) {
      texto += ` de ${edades.join(", ")} años`;
    }

    return texto;
  };

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    localStorage.setItem("formData", JSON.stringify(updatedFormData));
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    console.log("Datos guardados:", {
      ...formData,
      images,
    });

    navigate(`/domiciliaria/${evaluadosList_id}`);
  };

  useEffect(() => {
    const savedFormData = localStorage.getItem("formData");
    const savedZones = localStorage.getItem("selectedZones");
    if (savedFormData) {
      setFormData(JSON.parse(savedFormData));
    }

    const savedImages = localStorage.getItem("images");
    if (savedImages) {
      setImages(JSON.parse(savedImages));
    }
  }, []);

  const generoMap: { [key: string]: string } = {
    M: "Masculino",
    F: "Femenino",
    O: "Otro",
  };

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaSE = useGetData<FechaSocioeconomicaInterface[]>({
    url: `/fecha-socioeconomica/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha-socioeconomica"],
  });

  const queryEvaluacionSE = useGetData<ConclusionLlenadaSEInterface>({
    url: `/conclusionllenada_se/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "conclusionllenada_se"],
  });

  const generoTexto =
    generoMap[queryEvaluado.data?.genero as string] || "No especificado";

  const handlePrint = () => {
    const printContent = document.getElementById("printableContent");

    if (printContent) {
      const printWindow = window.open("", "", "width=800,height=600");

      if (printWindow) {
        printWindow.document.write(`
          <html>
            <head>
              <title>Vista Previa de Impresión</title>
              <style>
                @media print {
                  body {
                    margin: 20px;
                    font-family: Arial, sans-serif;
                  }
                }
              </style>
            </head>
            <body>${printContent.innerHTML}</body>
          </html>
        `);

        const styles = document.styleSheets;
        for (let i = 0; i < styles.length; i++) {
          try {
            if (styles[i].cssRules) {
              const styleTag = printWindow.document.createElement("style");
              for (let j = 0; j < styles[i].cssRules.length; j++) {
                styleTag.appendChild(
                  printWindow.document.createTextNode(
                    styles[i].cssRules[j].cssText
                  )
                );
              }
              printWindow.document.head.appendChild(styleTag);
            }
          } catch (e) {
            console.warn("No se pudo copiar una hoja de estilo:", e);
          }
        }

        printWindow.document.close();
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
            printWindow.close();
          }, 500);
        };
      } else {
        alert("No se pudo abrir la ventana de impresión.");
      }
    }
  };

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      console.log("Fecha de nacimiento:", fechaNac);
      console.log("Edad calculada:", nuevaEdad);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (queryFechaSE.data && queryFechaSE.data.length > 0) {
      const fechaps = queryFechaSE.data[0];
      reset({
        fecha_evaluacionse: fechaps.fecha_evaluacionse || "",
      });
    }
  }, [queryFechaSE.data, reset]);

  useEffect(() => {
    if (queryEvaluacionSE.data) {
      console.log("Datos cargados:", queryEvaluacionSE.data);
      reset({
        derivado_se: queryEvaluacionSE.data.derivado_se || "",
        regimen_se: queryEvaluacionSE.data.regimen_se || "",
        anioscasado_se: queryEvaluacionSE.data.anioscasado_se || "",
        numhijos_se: queryEvaluacionSE.data.numhijos_se || "",
        edadhijos_se: queryEvaluacionSE.data.edadhijos_se || "",
        numdependientes_se: queryEvaluacionSE.data.numdependientes_se || "",
        quienesdependen_se: queryEvaluacionSE.data.quienesdependen_se || "",
        aniostrabajando_se: queryEvaluacionSE.data.aniostrabajando_se || "",
        areapertenece_se: queryEvaluacionSE.data.areapertenece_se || "",
        fechalaborando_se: queryEvaluacionSE.data.fechalaborando_se || "",
        enterovacante_se: queryEvaluacionSE.data.enterovacante_se || "",
        recomendo_se: queryEvaluacionSE.data.recomendo_se || "",
        gastoalimentacion_se: queryEvaluacionSE.data.gastoalimentacion_se || "",
        gastovestido_se: queryEvaluacionSE.data.gastovestido_se || "",
        gastogasolina_se: queryEvaluacionSE.data.gastogasolina_se || "",
        gastotransporte_se: queryEvaluacionSE.data.gastotransporte_se || "",
        gastotelefono_se: queryEvaluacionSE.data.gastotelefono_se || "",
        gastodiversiones_se: queryEvaluacionSE.data.gastodiversiones_se || "",
        gastoautofinanciamiento_se:
          queryEvaluacionSE.data.gastoautofinanciamiento_se || "",
        gastootros1_se: queryEvaluacionSE.data.gastootros1_se || "",
        gastohipoteca_se: queryEvaluacionSE.data.gastohipoteca_se || "",
        gastorenta_se: queryEvaluacionSE.data.gastorenta_se || "",
        gastocolegiaturas_se: queryEvaluacionSE.data.gastocolegiaturas_se || "",
        gastoservicios_se: queryEvaluacionSE.data.gastoservicios_se || "",
        gastodeudas_se: queryEvaluacionSE.data.gastodeudas_se || "",
        gastoinversiones_se: queryEvaluacionSE.data.gastoinversiones_se || "",
        gastopension_se: queryEvaluacionSE.data.gastopension_se || "",
        gastootros2_se: queryEvaluacionSE.data.gastootros2_se || "",
        gastototal_se: queryEvaluacionSE.data.gastototal_se || "",
        ingresomensual_se: queryEvaluacionSE.data.ingresomensual_se || "",
        compuestopor_se: queryEvaluacionSE.data.compuestopor_se || "",
        ingresoesposa_se: queryEvaluacionSE.data.ingresoesposa_se || "",
        ingresosextra_se: queryEvaluacionSE.data.ingresosextra_se || "",
        ascienden_se: queryEvaluacionSE.data.ascienden_se || "",
        egresosfam_se: queryEvaluacionSE.data.egresosfam_se || "",
        compuestosde_se: queryEvaluacionSE.data.compuestosde_se || "",
        esposaegreso_se: queryEvaluacionSE.data.esposaegreso_se || "",
        deudasascienden1_se: queryEvaluacionSE.data.deudasascienden1_se || "",
        gastosaprox_se: queryEvaluacionSE.data.gastosaprox_se || "",
        deudasascienden2_se: queryEvaluacionSE.data.deudasascienden2_se || "",
        cuantosvehiculos_se: queryEvaluacionSE.data.cuantosvehiculos_se || "",
        marcavechiculo_se: queryEvaluacionSE.data.marcavechiculo_se || "",
        aniovehiculo_se: queryEvaluacionSE.data.aniovehiculo_se || "",
        adquiriovehiculo_se: queryEvaluacionSE.data.adquiriovehiculo_se || "",
        domicilioactual_se: queryEvaluacionSE.data.domicilioactual_se || "",
        tiempoviviendo_se: queryEvaluacionSE.data.tiempoviviendo_se || "",
        referenciavecinal1_se:
          queryEvaluacionSE.data.referenciavecinal1_se || "",
        referenciavecinal2_se:
          queryEvaluacionSE.data.referenciavecinal2_se || "",
        titularcuentabanco_se:
          queryEvaluacionSE.data.titularcuentabanco_se || "",
        tiempolibre_se: queryEvaluacionSE.data.tiempolibre_se || "",
        fuma_se: queryEvaluacionSE.data.fuma_se || "",
        cuantofuma_se: queryEvaluacionSE.data.cuantofuma_se || "",
        toma_se: queryEvaluacionSE.data.toma_se || "",
        cuantotoma_se: queryEvaluacionSE.data.cuantotoma_se || "",
        ultimavez_se: queryEvaluacionSE.data.ultimavez_se || "",
        consumedrogas_se: queryEvaluacionSE.data.consumedrogas_se || "",
        aniolaboral_se: queryEvaluacionSE.data.aniolaboral_se || "",
        externo1_se: queryEvaluacionSE.data.externo1_se || "",
        tiempolaborando1_se: queryEvaluacionSE.data.tiempolaborando1_se || "",
        tiempolaborando2_se: queryEvaluacionSE.data.tiempolaborando2_se || "",
        supervision_se: queryEvaluacionSE.data.supervision_se || "",
        telcoordinadora_se: queryEvaluacionSE.data.telcoordinadora_se || "",
        telsinexito_se: queryEvaluacionSE.data.telsinexito_se || "",
        externo2_se: queryEvaluacionSE.data.externo2_se || "",
        observaciones_se: queryEvaluacionSE.data.observaciones_se || "",
        drogasdescripcion_se: queryEvaluacionSE.data.drogasdescripcion_se || "",
        cuentaconfamiliares_se:
          queryEvaluacionSE.data.cuentaconfamiliares_se || "",
        comollego_se: queryEvaluacionSE.data.comollego_se || "",
        cuentasbancarias_se: queryEvaluacionSE.data.cuentasbancarias_se || "",
        cuantosinmuebles_se: queryEvaluacionSE.data.cuantosinmuebles_se || "",
        titulospropiedad_se: queryEvaluacionSE.data.titulospropiedad_se || "",
        comoadquirio1_se: queryEvaluacionSE.data.comoadquirio1_se || "",
        descripcionvehiculos: queryEvaluacionSE.data.descripcionvehiculos || "",
        titulosvehiculos_se: queryEvaluacionSE.data.titulosvehiculos_se || "",
        comoadquirio2_se: queryEvaluacionSE.data.comoadquirio2_se || "",
        procesospenales_se: queryEvaluacionSE.data.procesospenales_se || "",
        descripcionpenales_se:
          queryEvaluacionSE.data.descripcionpenales_se || "",
        anotedirecciones_se: queryEvaluacionSE.data.anotedirecciones_se || "",
        practicadeporte_se: queryEvaluacionSE.data.practicadeporte_se || "",
        cualdeporte_se: queryEvaluacionSE.data.cualdeporte_se || "",
        religionpertenece_se: queryEvaluacionSE.data.religionpertenece_se || "",
        estadosalud_se: queryEvaluacionSE.data.estadosalud_se || "",
        inmuebleperteece_se: queryEvaluacionSE.data.inmuebleperteece_se || "",
        relacionvecinos_se: queryEvaluacionSE.data.relacionvecinos_se || "",
        inpuestodemanda_se: queryEvaluacionSE.data.inpuestodemanda_se || "",
        motivodemanda_se: queryEvaluacionSE.data.motivodemanda_se || "",
        aniodemanda_se: queryEvaluacionSE.data.aniodemanda_se || "",
        tienecredito_se: queryEvaluacionSE.data.tienecredito_se || "",
        tipocredito_se: queryEvaluacionSE.data.tipocredito_se || "",
        autopaga_se: queryEvaluacionSE.data.autopaga_se || "",
        pagomensuales_se: queryEvaluacionSE.data.pagomensuales_se || "",
        tarjetaspaga_se: queryEvaluacionSE.data.tarjetaspaga_se || "",
        pagomensualtarjetas_se:
          queryEvaluacionSE.data.pagomensualtarjetas_se || "",
        tieneadeudoscredito_se:
          queryEvaluacionSE.data.tieneadeudoscredito_se || "",
        institucioncredito_se:
          queryEvaluacionSE.data.institucioncredito_se || "",
        cuantopagacredito_se: queryEvaluacionSE.data.cuantopagacredito_se || "",
        tienecreditofonacot_se:
          queryEvaluacionSE.data.tienecreditofonacot_se || "",
        cuantopagafonacot_se: queryEvaluacionSE.data.cuantopagafonacot_se || "",
        retrasocredito_se: queryEvaluacionSE.data.retrasocredito_se || "",
        burocredito_se: queryEvaluacionSE.data.burocredito_se || "",
        motivoburo_se: queryEvaluacionSE.data.motivoburo_se || "",
        ingresomensual2_se: queryEvaluacionSE.data.ingresomensual2_se || "",
        nombreprimaria_se: queryEvaluacionSE.data.nombreprimaria_se || "",
        ciudadprimaria_se: queryEvaluacionSE.data.ciudadprimaria_se || "",
        aniosprimaria_se: queryEvaluacionSE.data.aniosprimaria_se || "",
        periodoprimaria_se: queryEvaluacionSE.data.periodoprimaria_se || "",
        certificadoprimaria_se:
          queryEvaluacionSE.data.certificadoprimaria_se || "",
        nombresecundaria_se: queryEvaluacionSE.data.nombresecundaria_se || "",
        ciudadsecundaria_se: queryEvaluacionSE.data.ciudadsecundaria_se || "",
        aniossecundaria_se: queryEvaluacionSE.data.aniossecundaria_se || "",
        periodosecundaria_se: queryEvaluacionSE.data.periodosecundaria_se || "",
        certificadosecundaria_se:
          queryEvaluacionSE.data.certificadosecundaria_se || "",
        nombrebachillerato_se:
          queryEvaluacionSE.data.nombrebachillerato_se || "",
        ciudadbachillerato_se:
          queryEvaluacionSE.data.ciudadbachillerato_se || "",
        aniosbachillerato_se: queryEvaluacionSE.data.aniosbachillerato_se || "",
        periodobachillerato_se:
          queryEvaluacionSE.data.periodobachillerato_se || "",
        certificadobachillerato_se:
          queryEvaluacionSE.data.certificadobachillerato_se || "",
        nombrelicenciatura_se:
          queryEvaluacionSE.data.nombrelicenciatura_se || "",
        ciudadlicenciatura_se:
          queryEvaluacionSE.data.ciudadlicenciatura_se || "",
        anioslicenciatura_se: queryEvaluacionSE.data.anioslicenciatura_se || "",
        periodolicenciatura_se:
          queryEvaluacionSE.data.periodolicenciatura_se || "",
        certificadolicenciatura_se:
          queryEvaluacionSE.data.certificadolicenciatura_se || "",
        estudiaactualmente_se:
          queryEvaluacionSE.data.estudiaactualmente_se || "",
        dondeestudia_se: queryEvaluacionSE.data.dondeestudia_se || "",
        horarioestudio_se: queryEvaluacionSE.data.horarioestudio_se || "",
        indicarespecialidad_se:
          queryEvaluacionSE.data.indicarespecialidad_se || "",
        notaestudio_se: queryEvaluacionSE.data.notaestudio_se || "",
      });
    }
  }, [queryEvaluacionSE.data, reset]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  const renderPage1 = () => (
    <div className={`space-y-4 p-4 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
      <div className="grid grid-cols-3 gap-4">
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fecha_conclusionps" className={`mr-2 ${isDarkMode ? "text-gray-200" : "text-gray-700"}`}>
            FECHA:
          </Label>
          <Controller
            name="fecha_conclusionps"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="fecha_evaluacionse"
                type="date"
                value={
                  field.value ||
                  (queryFechaSE.data && queryFechaSE.data.length > 0
                    ? queryFechaSE.data[0]?.fecha_evaluacionse || ""
                    : "")
                }
                disabled={true}
                placeholder="Seleccionar fecha"
                className={`w-32 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
              />
            )}
          />
        </div>
        <div className="col-span-2">
          <Label htmlFor="nombre" className={isDarkMode ? "text-gray-200" : "text-gray-700"}>NOMBRE:</Label>
          <TextInput
            id="nombre"
            name="nombre"
            value={`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
            onChange={handleInputChange}
            disabled={true}
            className={isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}
          />
        </div>
        {/* Campo para RFC */}
        <div className="col-span-1">
          <Label htmlFor="rfc" className={isDarkMode ? "text-gray-200" : "text-gray-700"}>RFC:</Label>
          <TextInput
            id="rfc"
            name="rfc"
            onChange={handleInputChange}
            value={queryEvaluado.data?.rfc || ""}
            disabled={true}
            className={isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}
          />
        </div>
        {/* Edad */}
        <div className="col-span-1">
          <Label htmlFor="edad" className={isDarkMode ? "text-gray-200" : "text-gray-700"}>EDAD:</Label>
          <TextInput
            id="edad"
            name="edad"
            value={edad !== null ? edad.toString() : ""}
            disabled={true}
            className={isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="sexo" className={isDarkMode ? "text-gray-200" : "text-gray-700"}>SEXO:</Label>
          <TextInput
            id="sexo"
            name="sexo"
            value={generoTexto}
            disabled={true}
            className={isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="estadoCivil" className={isDarkMode ? "text-gray-200" : "text-gray-700"}>ESTADO CIVIL:</Label>
          <TextInput
            id="estadoCivil"
            name="estadoCivil"
            onChange={handleInputChange}
            value={`${queryEvaluado.data?.estado_civil || ""}`}
            disabled={true}
            className={isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="escolaridad" className={isDarkMode ? "text-gray-200" : "text-gray-700"}>ESCOLARIDAD:</Label>
          <TextInput
            id="escolaridad"
            name="escolaridad"
            onChange={handleInputChange}
            value={`${queryEvaluado.data?.escolaridad || ""}`}
            disabled={true}
            className={isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}
          />
        </div>
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fechaNacimiento" className={`mr-2 ${isDarkMode ? "text-gray-200" : "text-gray-700"}`}>
            FECHA DE NACIMIENTO:
          </Label>
          <TextInput
            id="fechaNacimiento"
            name="fechaNacimiento"
            value={`${queryEvaluado.data?.fecha_nacimiento || ""}`}
            disabled={true}
            type="date"
            onChange={handleInputChange}
            className={`w-32 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="curp" className={isDarkMode ? "text-gray-200" : "text-gray-700"}>CURP:</Label>
          <TextInput
            id="curp"
            name="curp"
            onChange={handleInputChange}
            value={queryEvaluado.data?.curp || ""}
            disabled={true}
            className={isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="empresa" className={isDarkMode ? "text-gray-200" : "text-gray-700"}>EMPRESA:</Label>
          <TextInput
            id="empresa_id"
            name="empresa"
            value={queryEvaluado.data?.empresa_id?.nombre || ""}
            onChange={handleInputChange}
            disabled={true}
            className={isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}
          />
        </div>
      </div>
    </div>
  );

  const renderPage2 = () => (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`bg-customBlue p-4 rounded-lg shadow ${isDarkMode ? "bg-blue-900 text-white" : "bg-customBlue text-white"}`}>
        <h2 className="font-bold text-xl">EVALUACIÓN DE PATRIMONIAL 1</h2>
      </div>

      {/* Tabla */}
      <div className="w-full overflow-x-auto">
        <table className={`min-w-full rounded-lg overflow-hidden border-2 ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-500"}`}>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-800 text-white" : "bg-blue-500 text-black"}`}>
              <th
                colSpan={3}
                className={`py-3 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
              >
                CUESTIONARIO INVESTIGACIÓN SOCIOECONÓMICA
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                Estado Civil
              </th>
              <th className={`py-2 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                En caso de estar casado, indique el régimen matrimonial
              </th>
              <th className={`py-2 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Cuántos años tiene de casado?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  value={
                    queryEvaluado.data?.estado_civil
                      ? queryEvaluado.data.estado_civil
                          .charAt(0)
                          .toUpperCase() +
                        queryEvaluado.data.estado_civil.slice(1)
                      : ""
                  }
                  placeholder="Estado Civil"
                  disabled={true}
                />
              </td>
              <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.regimen_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Régimen..."
                />
              </td>
              <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  disabled={true}
                  value={`${queryEvaluacionSE.data?.anioscasado_se || ""}`}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Cuantos años?"
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-3 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Cuántos hijos tiene y que edades tienen?
              </th>
              <th className={`py-3 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Cuántos dependientes económicos tiene y quiénes son?
              </th>
              <th className={`py-3 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                Empresa en la que labora, antigüedad y a qué área pertenece
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  disabled={true}
                  value={buildIntegrantesText()}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Integrantes"
                  readOnly
                />
              </td>
              <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.numdependientes_se}, ${queryEvaluacionSE.data?.quienesdependen_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Número de dependientes"
                />
              </td>
              <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  id="describe"
                  disabled={true}
                  value={`${
                    queryEvaluado.data?.empresa_id?.nombre || "" || ""
                  } con ${
                    queryEvaluado.data?.antiguedad || ""
                  } de antigüedad, en el área de ${
                    queryEvaluado.data?.puesto || ""
                  }
                  `}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Descripción"
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                Fecha de ingreso a la empresa en la que actualmente labora
              </th>
              <th className={`py-2 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Cuenta con familiares laborando en la empresa donde está
                actualmente?
              </th>
              <th className={`py-2 px-4 border text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Cómo se enteró del empleo?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`Ingresó el ${
                    queryEvaluado.data?.fecha_ingreso
                      ? new Date(
                          queryEvaluado.data.fecha_ingreso
                        ).toLocaleDateString("es-ES")
                      : ""
                  }
                      `}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Razón de identificación"
                />
              </td>
              <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  id="cuentaconfamiliares_se"
                  disabled={true}
                  value={`${
                    queryEvaluacionSE.data?.cuentaconfamiliares_se || ""
                  }`}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Cuenta con familiares en la empresa?"
                />
              </td>
              <td className={`py-2 px-4 border ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.enterovacante_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Como se enteró?"
                />
              </td>
            </tr>
          </thead>
        </table>
      </div>

     <div className="w-full overflow-x-auto">
        <table className={`min-w-full rounded-lg overflow-hidden border ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-300"}`}>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-800 text-white" : "bg-blue-500 text-black"}`}>
              <th colSpan={3} className={`py-3 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                CUESTIONARIO PARA INVESTIGACIÓN SOCIOECONÓMICA
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Cómo llego y quien le recomendó laborar en esa empresa?
              </th>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Cuánto asciende su ingreso mensual familiar y como este
                compuesto, incluyendo el de su esposa(o) de ser el caso, así
                como ingresos extras por conceptos de alquiler u otros?
              </th>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Cuáles son sus egresos mensuales familiares y como este
                compuesto, incluyendo el de su esposa de ser el caso, incluyendo
                deudas, gastos del hogar, diversiones etc.?
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  id="comollego_se"
                  value={`Llego por ${queryEvaluacionSE.data?.comollego_se} y ${queryEvaluacionSE.data?.recomendo_se} lo recomendó`}
                  disabled={true}
                  className={`w-full h-[150px] p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  aria-label="comollego_se"
                  placeholder="¿Cómo llegó?"
                />
              </td>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`Su ingreso familiar asciende a $ ${queryEvaluacionSE.data?.ingresomensual_se} y está compuesto por ${queryEvaluacionSE.data?.compuestopor_se}, el ingreso de su esposa asciende a $ ${queryEvaluacionSE.data?.ingresoesposa_se}, asi como sus ingresos extras son de $ ${queryEvaluacionSE.data?.ingresosextra_se}`}
                  disabled={true}
                  className={`w-full h-[150px] p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  aria-label="ingresomensual_se"
                  placeholder="Ingresos"
                />
              </td>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  id="egresosfam_se"
                  value={`Sus egresos familiares son de $ ${queryEvaluacionSE.data?.egresosfam_se} y está compuesto por ${queryEvaluacionSE.data?.compuestosde_se}, el egreso de su esposa es de $ ${queryEvaluacionSE.data?.esposaegreso_se}, asi como sus egresos extras son de $ ${queryEvaluacionSE.data?.deudasascienden1_se}`}
                  disabled={true}
                  className={`w-full h-[150px] p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Egresos mensuales familiares"
                />
              </td>
            </tr>
          </tbody>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿A cuánto ascienden sus deudas?
              </th>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Mencione las cuentas bancarias de las que Usted es titular?
              </th>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Cuántos inmuebles propios o en sociedad posee?, descríbalos,
                ¿Con que títulos de propiedad cuenta y como los adquirió?
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  id="deudasascienden2_se"
                  value={`$ ${queryEvaluacionSE.data?.deudasascienden2_se}`}
                  disabled={true}
                  className={`w-full h-[100px] p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Deudas..."
                />
              </td>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.cuentasbancarias_se}`}
                  disabled={true}
                  className={`w-full h-[100px] p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Cuentas Bancarias"
                />
              </td>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`Tiene ${queryEvaluacionSE.data?.cuantosinmuebles_se} propiedades y el titulo que posee es de ${queryEvaluacionSE.data?.titulospropiedad_se} y lo adquirió ${queryEvaluacionSE.data?.comoadquirio1_se}`}
                  disabled={true}
                  className={`w-full h-[100px] p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Cuantos Inmuebles?"
                />
              </td>
            </tr>
          </tbody>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Cuántos vehículos posee?, descríbalos, ¿Con que títulos de
                propiedad cuenta y como los adquirió?
              </th>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Cuenta con procesos penales o procedimientos administrativos?,
                en caso de que si, descríbalos
              </th>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Escriba el domicilio donde habita actualmente?
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  id="cuantosvehiculos_se"
                  value={`Tiene ${queryEvaluacionSE.data?.cuantosvehiculos_se} vehiculos y son ${queryEvaluacionSE.data?.descripcionvehiculos} y el titulo que posee es de ${queryEvaluacionSE.data?.titulosvehiculos_se} y los adquirió ${queryEvaluacionSE.data?.comoadquirio2_se}`}
                  disabled={true}
                  className={`w-full h-[250px] p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Cuántos?"
                />
              </td>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${
                    queryEvaluacionSE.data?.procesospenales_se === "true"
                      ? "Sí"
                      : "No"
                  }, ${queryEvaluacionSE.data?.descripcionpenales_se}`}
                  disabled={true}
                  className={`w-full h-[250px] p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Lo está?"
                />
              </td>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <Controller
                  name="domicilio"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      id="domicilio"
                      value={`${queryEvaluado.data?.calle || ""}, ${
                        queryEvaluado.data?.numero_exterior || ""
                      }, ${queryEvaluado.data?.colonia || ""}, ${
                        queryEvaluado.data?.codigo_postal || ""
                      }, ${queryEvaluado.data?.municipio || ""}, ${
                        queryEvaluado.data?.estado || ""
                      }, ${queryEvaluado.data?.pais || ""}`}
                      disabled={true}
                      className={`w-full h-[250px] p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                      placeholder="Domicilio..."
                    />
                  )}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="w-full overflow-x-auto">
        <table className={`min-w-full rounded-lg overflow-hidden border ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-300"}`}>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                Anote las direcciones
              </th>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                Anote dos referencias vecinales
              </th>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Qué hace en sus tiempos libres?
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.anotedirecciones_se}`}
                  disabled={true}
                  className={`w-full h-[150px] p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Direcciones..."
                />
              </td>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.referenciavecinal1_se} y ${queryEvaluacionSE.data?.referenciavecinal2_se}`}
                  disabled={true}
                  className={`w-full h-[150px] p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Referencia..."
                />
              </td>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.tiempolibre_se}`}
                  disabled={true}
                  className={`w-full h-[150px] p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Que hace en su tiempo libre?"
                />
              </td>
            </tr>
          </tbody>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Practica algún deporte? (Si/No) ¿Cuál?
              </th>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿A que religión pertenece?
              </th>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Cómo considera su estado de salud y por qué?
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${
                    queryEvaluacionSE.data?.practicadeporte_se === "true"
                      ? "Sí"
                      : "No"
                  }, ${queryEvaluacionSE.data?.cualdeporte_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Qué hace en su tiempo libre?"
                />
              </td>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.religionpertenece_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Qué religión?"
                />
              </td>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.estadosalud_se}, ${queryEvaluacionSE.data?.derivado_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Estado de salud..."
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="w-full overflow-x-auto">
        <table
          className={`min-w-full rounded-lg overflow-hidden border ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-300"}`}
          style={{ tableLayout: "fixed" }}
        >
          {/* Encabezado principal */}
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-800 text-white" : "bg-blue-500 text-black"}`}>
              <th colSpan={3} className={`py-3 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                CUESTIONARIO PARA INVESTIGACIÓN SOCIOECONÓMICA
              </th>
            </tr>
          </thead>

          {/* Encabezado secundario */}
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th colSpan={3} className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                Elabore un croquis de su domicilio actual, entre que calles y
                referencias
              </th>
            </tr>
          </thead>
        </table>
      </div>

      {/* Croquis */}
      <div className="mt-4 mb-4 w-full">
        <div className="flex justify-center mt-2">
          <img
            src={imageUrl}
            alt="Croquis"
            className={`w-full max-w-[800px] h-auto border-2 rounded-lg ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
          />
        </div>
      </div>

      <div className="w-full overflow-x-auto">
        <table className={`min-w-full rounded-lg overflow-hidden border ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-300"}`}>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Cuánto tiempo tiene viviendo en ese inmueble?
              </th>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿A quién pertenece el inmueble donde habita actualmente?
              </th>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Cómo es la relación que lleva con sus vecinos?
              </th>
            </tr>
          </thead>

          {/* Textareas para las preguntas sobre el inmueble */}
          <tbody>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.tiempoviviendo_se} años`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Tiempo en el inmueble"
                />
              </td>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.inmuebleperteece_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Propietario del inmueble"
                />
              </td>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.relacionvecinos_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Relación con vecinos"
                />
              </td>
            </tr>
          </tbody>

          {/* Preguntas sobre hábitos */}
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                Fuma, ¿Cuántos cigarros al día aproximadamente?
              </th>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                Consume bebidas alcohólicas, ¿Con qué frecuencia y cuándo fue la
                última vez?
              </th>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Ha consumido o consume algún tipo de droga?
              </th>
            </tr>
          </thead>

          {/* Textareas para las preguntas sobre hábitos */}
          <tbody>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${
                    queryEvaluacionSE.data?.fuma_se === "true" ? "Sí" : "No"
                  }, ${queryEvaluacionSE.data?.cuantofuma_se} cigarros al día`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Propietario del inmueble"
                />
              </td>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${
                    queryEvaluacionSE.data?.toma_se === "true" ? "Sí" : "No"
                  }, ${
                    queryEvaluacionSE.data?.cuantotoma_se
                  }, siendo la última vez el ${
                    queryEvaluacionSE.data?.ultimavez_se
                      ? new Date(
                          queryEvaluacionSE.data.ultimavez_se + "T00:00:00"
                        ).toLocaleDateString("es-ES")
                      : "Fecha no disponible"
                  }`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Consume?"
                />
              </td>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${
                    queryEvaluacionSE.data?.consumedrogas_se === "true"
                      ? "Sí"
                      : "No"
                  }`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Consume?"
                />
              </td>
            </tr>
          </tbody>

          {/* Preguntas sobre demandas laborales */}
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Ha interpuesto demandas laborales?
              </th>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                En caso afirmativo, explique los motivos
              </th>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿En qué año fue interpuesta?
              </th>
            </tr>
          </thead>

          {/* Textareas para las preguntas sobre demandas laborales */}
          <tbody>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.inpuestodemanda_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Demandas laborales"
                />
              </td>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.motivodemanda_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Motivos de las demandas"
                />
              </td>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${
                    queryEvaluacionSE.data?.aniodemanda_se
                      ? new Date(queryEvaluacionSE.data.aniodemanda_se)
                          .toISOString()
                          .split("T")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      : ""
                  }`}
                  id="aniodemanda_se"
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Año de la demanda"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="w-full overflow-x-auto">
        <table
          className={`min-w-full rounded-lg overflow-hidden border ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-300"}`}
          style={{ tableLayout: "fixed" }}
        >
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-800 text-white" : "bg-blue-500 text-black"}`}>
              <th className={`py-3 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                INFORMACIÓN DE CRÉDITOS
              </th>
            </tr>
          </thead>

          <tbody>
            <tr className={`${isDarkMode ? "bg-blue-700 text-white" : "bg-blue-400 text-black"}`}></tr>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Tienes algún crédito?
              </th>
            </tr>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${
                    queryEvaluacionSE.data?.tienecredito_se === "true"
                      ? "Sí"
                      : "No"
                  }`}
                  disabled={true}
                  className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Lo tiene?"
                />
              </td>
            </tr>
          </tbody>

          {/* Responsabilidad */}
          <tbody>
            <tr className={`${isDarkMode ? "bg-blue-700 text-white" : "bg-blue-400 text-black"}`}></tr>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Qué tipo de crédito es?
              </th>
            </tr>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <div>
                  <textarea
                    value={`${queryEvaluacionSE.data?.tipocredito_se}`}
                    disabled={true}
                    className={`w-full border rounded-md p-2 mt-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                    placeholder="Motivos de las demandas"
                  />
                </div>
              </td>
            </tr>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                Automóvil (es) que está pagando
              </th>
            </tr>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.autopaga_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Auto..."
                />
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                Pago (s) Mensual (es)
              </th>
            </tr>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`$ ${queryEvaluacionSE.data?.pagomensuales_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Pago..."
                />
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                Tarjetas de crédito que está pagando
              </th>
            </tr>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.tarjetaspaga_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Tarjetas..."
                />
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                Pago mensual (total) a tarjetas
              </th>
            </tr>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  id="pagomensualtarjetas_se"
                  value={`$ ${queryEvaluacionSE.data?.pagomensualtarjetas_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Pago..."
                />
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Tiene adeudos?
              </th>
            </tr>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${
                    queryEvaluacionSE.data?.tieneadeudoscredito_se === "true"
                      ? "Sí"
                      : "No"
                  }`}
                  disabled={true}
                  className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Tiene?"
                />
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Con qué institución tiene el crédito hipotecario?
              </th>
            </tr>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.institucioncredito_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Con cual?..."
                />
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>¿Cuánto paga?</th>
            </tr>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`$ ${queryEvaluacionSE.data?.cuantopagacredito_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Cuánto?..."
                />
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Tiene crédito FONACOT?
              </th>
            </tr>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${
                    queryEvaluacionSE.data?.tienecreditofonacot_se === "true"
                      ? "Sí"
                      : "No"
                  }`}
                  disabled={true}
                  className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Tiene?"
                />
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>¿Cuánto paga?</th>
            </tr>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`$ ${queryEvaluacionSE.data?.cuantopagafonacot_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Cuánto?"
                />
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Tiene retraso en alguno de los créditos?
              </th>
            </tr>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${
                    queryEvaluacionSE.data?.retrasocredito_se === "true"
                      ? "Sí"
                      : "No"
                  }`}
                  disabled={true}
                  className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Tiene?"
                />
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-200 text-black"}`}>
              <th className={`py-2 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                ¿Estás en buró de crédito? Especifique
              </th>
            </tr>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${
                    queryEvaluacionSE.data?.burocredito_se === "true"
                      ? "Sí"
                      : "No"
                  }`}
                  disabled={true}
                  className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Lo está?"
                />
                <textarea
                  id="motivoburo_se"
                  value={`${queryEvaluacionSE.data?.motivoburo_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Especifique..."
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="w-full overflow-x-auto">
        <table className={`min-w-full rounded-lg overflow-hidden border ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-300"}`}>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-800 text-white" : "bg-blue-500 text-black"}`}>
              <th className={`py-3 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                DISTRIBUCIÓN DE GASTOS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <span>
                  <strong className={isDarkMode ? "text-gray-100" : "text-black"}>INGRESOS ESTIMADOS EN FAMILIA:</strong> $
                  <input
                    value={`${queryEvaluacionSE.data?.ingresomensual_se}`}
                    disabled={true}
                    type="text"
                    className={`border rounded-md p-2 w-auto inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                    placeholder="$0"
                  />
                  .00, / $
                  <input
                    value={`${queryEvaluacionSE.data?.ingresomensual2_se}`}
                    disabled={true}
                    type="text"
                    className={`border rounded-md p-2 w-auto inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                    placeholder="Ocasión responsabilidad"
                  />
                  .00 ingreso de su pareja y / $
                  <input
                    id="ingresoesposa_se"
                    value={`${queryEvaluacionSE.data?.ingresoesposa_se}`}
                    disabled={true}
                    type="text"
                    className={`border rounded-md p-2 w-auto inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                    placeholder="Ocasión responsabilidad"
                  />
                  .00 ingreso del evaluado.
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* Tabla de distribución mensual de gastos */}
     <div className="w-full overflow-x-auto">
        <table className={`table-auto border-collapse w-full ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-300"}`}>
          {/* Header */}
          <thead>
            <tr>
              <th
                className={`border px-4 py-2 text-center font-semibold ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-gray-100 text-gray-700 border-gray-300"}`}
                colSpan={2}
              >
                DISTRIBUCION MENSUAL DE GASTOS
              </th>
            </tr>
          </thead>
          <tbody>
            {/* Filas */}
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Alimentación
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`$ ${queryEvaluacionSE.data?.gastoalimentacion_se}`}
                  disabled={true}
                  type="numeric"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$1,000"
                />
              </td>
            </tr>
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Vestido y Calzado
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`$ ${queryEvaluacionSE.data?.gastovestido_se}`}
                  disabled={true}
                  type="numeric"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$1,000"
                />
              </td>
            </tr>
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Gasolina
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`$ ${queryEvaluacionSE.data?.gastogasolina_se}`}
                  disabled={true}
                  type="numeric"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$1,000"
                />
              </td>
            </tr>
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Transporte
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`$ ${queryEvaluacionSE.data?.gastotransporte_se}`}
                  disabled={true}
                  type="numeric"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$1,000"
                />
              </td>
            </tr>
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Teléfono
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`$ ${queryEvaluacionSE.data?.gastotelefono_se}`}
                  disabled={true}
                  type="numeric"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$1,000"
                />
              </td>
            </tr>
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Diversiones
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`$ ${queryEvaluacionSE.data?.gastodiversiones_se}`}
                  disabled={true}
                  type="numeric"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$1,000"
                />
              </td>
            </tr>
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Autofinanciamiento
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  id="gastoautofinanciamiento_se"
                  value={`$ ${queryEvaluacionSE.data?.gastoautofinanciamiento_se}`}
                  disabled={true}
                  type="numeric"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$1,000"
                />
              </td>
            </tr>
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Otros
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`$ ${queryEvaluacionSE.data?.gastootros1_se}`}
                  disabled={true}
                  type="numeric"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$1,000"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div>
          <br />
        </div>
        <table className={`table-auto border-collapse w-full ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-300"}`}>
          <tbody>
            {/* Filas */}
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Hipoteca
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`$ ${queryEvaluacionSE.data?.gastohipoteca_se}`}
                  disabled={true}
                  type="numeric"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$1,000"
                />
              </td>
            </tr>
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Renta
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`$ ${queryEvaluacionSE.data?.gastorenta_se}`}
                  disabled={true}
                  type="numeric"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$1,000"
                />
              </td>
            </tr>
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Colegiaturas
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`$ ${queryEvaluacionSE.data?.gastocolegiaturas_se}`}
                  disabled={true}
                  type="numeric"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$1,000"
                />
              </td>
            </tr>
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Servicios
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`$ ${queryEvaluacionSE.data?.gastoservicios_se}`}
                  disabled={true}
                  type="numeric"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$1,000"
                />
              </td>
            </tr>
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Deudas
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`$ ${queryEvaluacionSE.data?.gastodeudas_se}`}
                  disabled={true}
                  type="numeric"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$1,000"
                />
              </td>
            </tr>
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Inversiones
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`$ ${queryEvaluacionSE.data?.gastoinversiones_se}`}
                  disabled={true}
                  type="numeric"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$1,000"
                />
              </td>
            </tr>
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Pensión Alimenticia
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  id="gastopension_se"
                  value={`$ ${queryEvaluacionSE.data?.gastopension_se}`}
                  disabled={true}
                  type="numeric"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$1,000"
                />
              </td>
            </tr>
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Otros
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  id="gastootros2_se"
                  value={`$ ${queryEvaluacionSE.data?.gastootros2_se}`}
                  disabled={true}
                  type="numeric"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$1,000"
                />
              </td>
            </tr>
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                Total
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  id="gastototal_se"
                  disabled={true}
                  type="text"
                  className={`border px-4 py-2 rounded-md w-auto inline-block focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="$0.00"
                  value={`$ ${[
                    "gastoalimentacion_se",
                    "gastovestido_se",
                    "gastogasolina_se",
                    "gastotransporte_se",
                    "gastotelefono_se",
                    "gastodiversiones_se",
                    "gastoautofinanciamiento_se",
                    "gastootros1_se",
                    "gastohipoteca_se",
                    "gastorenta_se",
                    "gastocolegiaturas_se",
                    "gastoservicios_se",
                    "gastodeudas_se",
                    "gastoinversiones_se",
                    "gastopension_se",
                    "gastootros2_se",
                  ]
                    .map((name) => parseFloat(getValues(name)) || 0)
                    .reduce((acc, value) => acc + value, 0)
                    .toFixed(2)}`}
                  readOnly
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="w-full overflow-x-auto">
        <table className={`min-w-full rounded-lg overflow-hidden border ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-300"}`}>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-800 text-white" : "bg-blue-500 text-black"}`}>
              <th
                colSpan={6}
                className={`py-3 px-4 border-b text-center ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
              >
                ESCOLARIDAD
              </th>
            </tr>
          </thead>
          <thead className={`${isDarkMode ? "bg-gray-700 text-white" : "bg-gray-100"}`}>
            <tr>
              <th className={`border px-4 py-2 text-left font-semibold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                NIVEL
              </th>
              <th className={`border px-4 py-2 text-left font-semibold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                NOMBRE DE LA INSTITUCIÓN
              </th>
              <th className={`border px-4 py-2 text-left font-semibold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                CIUDAD
              </th>
              <th className={`border px-4 py-2 text-left font-semibold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                AÑOS CURSADOS
              </th>
              <th className={`border px-4 py-2 text-left font-semibold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                PERIODO
              </th>
              <th className={`border px-4 py-2 text-left font-semibold ${isDarkMode ? "text-white border-gray-600" : "text-gray-700 border-gray-300"}`}>
                CERTIFICADO
              </th>
            </tr>
          </thead>
          <tbody>
            {/* Primaria */}
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                PRIMARIA
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  id="nombreprimaria_se"
                  value={`${queryEvaluacionSE.data?.nombreprimaria_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Institución"
                />
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.ciudadprimaria_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Ciudad"
                />
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.aniosprimaria_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Años"
                />
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  id="periodoprimaria_se"
                  value={`${queryEvaluacionSE.data?.periodoprimaria_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Periodo"
                />
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  id="certificadoprimaria_se"
                  value={`${queryEvaluacionSE.data?.certificadoprimaria_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Periodo"
                />
              </td>
            </tr>

            {/* Secundaria */}
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                SECUNDARIA
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  id="nombresecundaria_se"
                  value={`${queryEvaluacionSE.data?.nombresecundaria_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Institución"
                />
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  id="ciudadsecundaria_se"
                  value={`${queryEvaluacionSE.data?.ciudadsecundaria_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Ciudad"
                />
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.aniossecundaria_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Años"
                />
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.periodosecundaria_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Periodo"
                />
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.certificadosecundaria_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Periodo"
                />
              </td>
            </tr>

            {/* Bachillerato */}
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                BACHILLERATO
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.nombrebachillerato_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Institución"
                />
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  id="ciudadbachillerato_se"
                  value={`${queryEvaluacionSE.data?.ciudadbachillerato_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Ciudad"
                />
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.aniosbachillerato_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Años"
                />
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.periodobachillerato_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Periodo"
                />
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.certificadobachillerato_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Lo tiene?"
                />
              </td>
            </tr>

            {/* Licenciatura */}
            <tr>
              <td className={`border px-4 py-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                LICENCIATURA
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.nombrelicenciatura_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Institución"
                />
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.ciudadlicenciatura_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Ciudad"
                />
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.anioslicenciatura_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Años"
                />
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.periodolicenciatura_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Periodo"
                />
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.certificadolicenciatura_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-1 text-sm focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="¿Lo tiene?"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="overflow-x-auto">
        <table className={`min-w-full rounded-lg overflow-hidden border ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-300"}`}>
          <tbody>
            {/* Pregunta: ¿Estudia actualmente? */}
            <tr>
              <td className={`border px-4 py-2 font-semibold ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                ¿Estudia actualmente?
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.estudiaactualmente_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Respuesta"
                />
              </td>
            </tr>

            {/* Pregunta: ¿En dónde? */}
            <tr>
              <td className={`border px-4 py-2 font-semibold ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                ¿En dónde?
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.dondeestudia_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Lugar de estudio"
                />
              </td>
            </tr>

            {/* Pregunta: ¿Horario? */}
            <tr>
              <td className={`border px-4 py-2 font-semibold ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                ¿Horario?
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.horarioestudio_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Horario de estudio"
                />
              </td>
            </tr>

            {/* Nota adicional */}
            <tr>
              <td className={`border px-4 py-2 font-semibold ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-700 border-gray-300"}`}>
                En caso de contar con Carrera Técnica y/o Licenciatura, indicar
                especialidad.
              </td>
              <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <input
                  value={`${queryEvaluacionSE.data?.indicarespecialidad_se}`}
                  disabled={true}
                  type="text"
                  className={`w-full border rounded-md p-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  placeholder="Horario de estudio"
                />
              </td>
            </tr>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td colSpan={2} className={`py-2 px-4 border-b ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <textarea
                  value={`${queryEvaluacionSE.data?.notaestudio_se}`}
                  disabled={true}
                  className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${isDarkMode ? "bg-gray-700 text-white placeholder-gray-400 border-gray-600" : "bg-white text-gray-700 placeholder-gray-500 border-gray-300"}`}
                  aria-label="notaestudio_se"
                  placeholder="Nota..."
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`max-w-4xl mx-auto shadow-lg rounded-lg overflow-hidden mt-4 mb-4 relative ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
        <form
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
          onSubmit={handleSubmit}
        >
          {renderHeader()}

          {currentPage === 1 && renderPage1()}
          {currentPage === 2 && renderPage2()}

          <div className="mt-6 p-4 flex justify-between">
            {/* Botón Cancelar en renderPage1 (lado izquierdo) */}
            {currentPage === 1 && (
              <Button
                color="red"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/socioeconomica/${evaluadosList_id}`);
                }}
                className={`ml-2 ${isDarkMode ? "bg-red-700 text-white" : ""}`}
              >
                Cancelar
              </Button>
            )}

            {/* Botón Siguiente en renderPage1 (lado derecho) */}
            {currentPage === 1 && (
              <button
                type="button"
                className={`rounded px-4 py-2 text-white ${isDarkMode ? "bg-blue-700" : "bg-blue-500"}`}
                onClick={() => {
                  window.scrollTo(0, 0);
                  handlePageChange(currentPage + 1);
                }}
              >
                Siguiente
              </button>
            )}

            {currentPage > 1 && (
              <Button
                color="blue"
                onClick={() => {
                  window.scrollTo(0, 0);
                  handlePageChange(currentPage - 1);
                }}
                className={isDarkMode ? "bg-blue-700 text-white" : ""}
              >
                Anterior
              </Button>
            )}

            {/* Botón Guardar */}
            {currentPage === 2 && (
              <div className="flex space-x-4">
                <Button 
                  color="blue" 
                  onClick={handlePrint}
                  className={isDarkMode ? "bg-blue-700 text-white" : ""}
                >
                  Imprimir
                </Button>
                <button
                  type="button"
                  className={`rounded px-4 py-2 text-white ${isDarkMode ? "bg-red-700" : "bg-red-500"}`}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate(`/socioeconomica/${evaluadosList_id}`);
                  }}
                >
                  Salir
                </button>
              </div>
            )}
          </div>
        </form>
        {/* Imprimir */}
        <div id="printableContent" style={{ display: "none" }}>
          <EvaluacionPatrimonial1ListaPrint />
        </div>
      </div>

    </div>
  );
};
